module.exports = __webpack_public_path__ + "img/arrow_blue.7cae9ac8.svg";